import axios, { AxiosError } from 'axios';
import auth from './auth';
import monks from './monks';
import telegram from './telegram';
import media from './media';

export const auth_client = axios.create({
    baseURL: 'https://auth.thelistproduction.com',
    withCredentials: true,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem("jwt")}`
    }
})
export const client = axios.create({
    withCredentials: true,
    baseURL: 'https://api.thelistproduction.com',
    headers: {
        'Authorization': `Bearer ${localStorage.getItem("jwt")}`
    }
});
export const media_client = axios.create({
    withCredentials: true,
    baseURL: process.env.VUE_APP_MEDIA_URI,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem("jwt")}`
    }
});

export const handleError = (err: AxiosError) => {

    switch(err.response?.status){

        case 400:
            return `Parametri mancanti (${err.response.data.parameters.join(", ")})`;
        case 401:
            return `Credenziali invalide`
        case 500:
        default:
            return `Errore generico`;

    }

}


export default { auth, monks, telegram, media }